import { Component } from '@angular/core';

@Component({
  selector: 'fdx-home-page',
  templateUrl: './home-page.component.html',
  host: {
    class:
      'd-flex flex-column flex-grow-1 justify-content-center animated fadeIn slow'
  }
})
export class HomePageComponent {}
